document.addEventListener("DOMContentLoaded", function() {

    $("#send_product_form").hide();
    $("#coverage-postal-code").hide();
    $("#colect_product_form").show();

    $('input[name="bill_option"]').change(function() {
        if ($(this).val() === "bill_yes") {
            $("#modal_bill_form").show();
        } else {
            $("#modal_bill_form").hide();
        }
    });

    $('input[name="radio_entrega"]').change(function() {
        if ($(this).val() === "domicilio") {
            $("#coverage-postal-code").show();
            $("#colect_product_form").hide();
        } else {
            $("#coverage-postal-code").hide();
            $("#colect_product_form").show();
            $("#send_product_form").hide();

            $("#postal_code").val('');
            $("#address_line").val('');
            $("#colony").val('');
            $("#city").val('');
        }
    });

    $('#verify-coverage').on('click', function() {
        $("#response-message").html('');
        var postalCodeValue = $('#postal_code').val();
        var url = $(this).data('url');

        $.ajax({
            url: url,
            method: 'GET',
            data: { postal_code: postalCodeValue },
            success: function(response) {
                if (response.coverage) {
                    $("#city").val(response.coverage.city);
                    $('#country_id option[value='+response.coverage.province_id+']').prop("selected", true);
                    $("#send_product_form").show();
                } else {
                    $("#response-message").html('<span class="text-danger">'+ Lang.get('messages.cp_not_found') +'</span>');

                    $("#send_product_form").hide();
                }
            },
            error: function(xhr, status, error) {
                $("#response-message").html('Has introducido un Código Postal incorrecto');
                $("#send_product_form").hide();
            }
        });

    });


    var selectElement = document.getElementById('state-dealers');
    var shopSelect = $('#shop');
    var pickupstoreIdSelect = $('#pickupstoreIdSelect');
    var pickupstoreIdOldSelect = $('#pickupstoreIdOldSelect');
    var selectState = 'Selecciona un Estado';
    var dealersData = []; // Variable para almacenar los datos de las tiendas

    shopSelect.append($('<option>', {
        value: '',
        text: selectState
    }));

    selectElement.addEventListener('change', function() {
        var selectedValue = selectElement.value;
        var url = $(this).data('url');

        $('#response-info-dealers').empty();
        shopSelect.empty();
        if (!selectedValue) {
            shopSelect.append($('<option>', {
                value: '',
                text: selectState
            }));
        } else {
            $.ajax({
                url: url,
                method: 'GET',
                data: { id: selectedValue },
                success: function(response) {
                    dealersData = response; // Almacenar la respuesta
                    $.each(response, function(index, shop) {

                        var isSelected = pickupstoreIdSelect.val() == shop.id;
                        if (isSelected == false){
                            isSelected = pickupstoreIdOldSelect.val() == shop.id;
                        }

                        shopSelect.append($('<option>', {
                            value: shop.id,
                            text: shop.full_name,
                            selected: isSelected
                        }));

                    });
                    if (response.length > 0) {
                        displayDealerInfo(response[0]); // Mostrar información de la primera tienda
                    }
                },
                error: function(xhr, status, error) {
                    // Manejo de errores
                }
            });
        }
    });

    if (selectElement.value) {
        selectElement.dispatchEvent(new Event('change'));
    }

    shopSelect.on('change', function() {

        var selectedShopId = $(this).val();
        var selectedShop = dealersData.find(function(shop) {
            console.log(selectedShopId);
            return shop.id == selectedShopId;
        });

        if (selectedShop) {
            displayDealerInfo(selectedShop);
        } else {
            $('#response-info-dealers').empty();
        }
    });

    // Dealer for Delivery
    var selectElement2 = document.getElementById('state-dealers2');
    var shopSelect2 = $('#shop2');
    var deliverydealerSelect = $('#deliverydealerSelect');
    var selectState2 = 'Selecciona una tienda';
    var dealersData2 = []; // Variable para almacenar los datos de las tiendas

    shopSelect2.append($('<option>', {
        value: '',
        text: selectState2
    }));

    if(selectElement2){
        selectElement2.addEventListener('change', function() {
            var selectedValue = selectElement2.value;
            var url = $(this).data('url');

            $('#response-info-dealers2').empty();
            shopSelect2.empty();
            if (!selectedValue) {
                shopSelect2.append($('<option>', {
                    value: '',
                    text: selectState2
                }));
            } else {
                $.ajax({
                    url: url,
                    method: 'GET',
                    data: { id: selectedValue },
                    success: function(response) {
                        dealersData2 = response; // Almacenar la respuesta
                        shopSelect2.append($('<option>', {
                            value: '',
                            text: selectState2
                        }));
                        $.each(response, function(index, shop2) {
                            var isSelected = deliverydealerSelect.val() == shop2.id;
                            shopSelect2.append($('<option>', {
                                value: shop2.id,
                                text: shop2.full_name,
                                selected: isSelected
                            }));
                        });
                        if (response.length > 0) {
                            displayDealerInfo(response[0]); // Mostrar información de la primera tienda
                        }
                    },
                    error: function(xhr, status, error) {
                        // Manejo de errores
                    }
                });
            }
        });

        if (selectElement2.value) {
            selectElement2.dispatchEvent(new Event('change'));
        }
    }

    shopSelect2.on('change', function() {

        var selectedShopId = $(this).val();
        var selectedShop = dealersData2.find(function(shop) {
            return shop.id == selectedShopId;
        });

        if (selectedShop) {
            displayDealerInfo(selectedShop);
        } else {
            $('#response-info-dealers2').empty();
        }
    });

    function displayDealerInfo(dealer) {
        var googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(dealer.address)}`;
        var dealerInfo = `
    <div class="c-dealers__data">
        <h3 class="c-dealers__name d-flex w-100 justify-content-between p-0">
            <div class="mt-2">${dealer.name}</div>
            <div class="align-items-center">
                <a href="${googleMapsUrl}" class="btn btn-sm o-custom-button-main p-2" target="_blank">Mapa</a>
            </div>
        </h3>
        <div class="c-dealers__address p-0">${dealer.address}</div>
        ${dealer.schedule ? `<div class="c-dealers__info p-0"><strong>Horario: </strong>${dealer.schedule}</div>` : ''}
    </div>
    <br>
    `;
        $('#response-info-dealers').html(dealerInfo);
        $('#response-info-dealers2').html(dealerInfo);
    }

});


